"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFunctionBody = getFunctionBody;
exports.setDescriptor = setDescriptor;
exports.setDescriptors = setDescriptors;
exports.propertyIsAccessor = propertyIsAccessor;
exports.getInheritedDescriptor = getInheritedDescriptor;
exports.getInheritedPropertyNames = getInheritedPropertyNames;
exports.WeakTwoWayMap = void 0;

var _set = _interopRequireDefault(require("@babel/runtime/core-js/set"));

var _from = _interopRequireDefault(require("@babel/runtime/core-js/array/from"));

var _getOwnPropertyNames = _interopRequireDefault(require("@babel/runtime/core-js/object/get-own-property-names"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime/core-js/object/get-own-property-descriptors"));

var _defineProperty = _interopRequireDefault(require("@babel/runtime/core-js/object/define-property"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime/core-js/object/get-own-property-descriptor"));

var _weakMap = _interopRequireDefault(require("@babel/runtime/core-js/weak-map"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WeakTwoWayMap =
/*#__PURE__*/
function () {
  function WeakTwoWayMap() {
    (0, _classCallCheck2.default)(this, WeakTwoWayMap);
    this.m = new _weakMap.default();
  }

  (0, _createClass2.default)(WeakTwoWayMap, [{
    key: "set",
    value: function set(a, b) {
      this.m.set(a, b);
      this.m.set(b, a);
    }
  }, {
    key: "get",
    value: function get(item) {
      return this.m.get(item);
    }
  }, {
    key: "has",
    value: function has(item) {
      return this.m.has(item);
    }
  }]);
  return WeakTwoWayMap;
}();

exports.WeakTwoWayMap = WeakTwoWayMap;

// assumes the function opening, body, and closing are on separate lines
function getFunctionBody(fn) {
  var code = fn.toString().split("\n");
  code.shift(); // remove opening line (function() {)

  code.pop(); // remove closing line (})

  return code.join("\n");
}

var descriptorDefaults = {
  enumerable: true,
  configurable: true // makes it easier and less verbose to work with descriptors

};

function setDescriptor(obj, key, newDescriptor, inherited) {
  if (inherited === void 0) inherited = false;
  var currentDescriptor = inherited ? getInheritedDescriptor(obj, key) : (0, _getOwnPropertyDescriptor.default)(obj, key);
  newDescriptor = overrideDescriptor(currentDescriptor, newDescriptor);
  (0, _defineProperty.default)(obj, key, newDescriptor);
}

function setDescriptors(obj, newDescriptors) {
  var newDescriptor;
  var currentDescriptor;
  var currentDescriptors = (0, _getOwnPropertyDescriptors.default)(obj);

  for (var key in newDescriptors) {
    newDescriptor = newDescriptors[key];
    currentDescriptor = currentDescriptors[key];
    newDescriptors[key] = overrideDescriptor(currentDescriptor, newDescriptor);
  }

  (0, _defineProperties.default)(obj, newDescriptors);
}

function overrideDescriptor(oldDescriptor, newDescriptor) {
  if (('get' in newDescriptor || 'set' in newDescriptor) && ('value' in newDescriptor || 'writable' in newDescriptor)) {
    throw new TypeError('cannot specify both accessors and a value or writable attribute');
  }

  if (oldDescriptor) {
    if ('get' in newDescriptor || 'set' in newDescriptor) {
      delete oldDescriptor.value;
      delete oldDescriptor.writable;
    } else if ('value' in newDescriptor || 'writable' in newDescriptor) {
      delete oldDescriptor.get;
      delete oldDescriptor.set;
    }
  }

  return (0, _objectSpread2.default)({}, descriptorDefaults, oldDescriptor, newDescriptor);
}

function propertyIsAccessor(obj, key, inherited) {
  if (inherited === void 0) inherited = true;
  var result = false;
  var descriptor;

  if (arguments.length === 1) {
    descriptor = obj;
  } else {
    descriptor = inherited ? getInheritedDescriptor(obj, key) : (0, _getOwnPropertyDescriptor.default)(obj, key);
  }

  if (descriptor && (descriptor.get || descriptor.set)) {
    result = true;
  }

  return result;
}

function getInheritedDescriptor(obj, key) {
  var currentProto = obj;
  var descriptor;

  while (currentProto) {
    descriptor = (0, _getOwnPropertyDescriptor.default)(currentProto, key);

    if (descriptor) {
      descriptor.owner = currentProto;
      return descriptor;
    }

    currentProto = currentProto.__proto__;
  }
}

function getInheritedPropertyNames(obj) {
  var currentProto = obj;
  var keys = [];

  while (currentProto) {
    keys = keys.concat((0, _getOwnPropertyNames.default)(currentProto));
    currentProto = currentProto.__proto__;
  } // remove duplicates


  keys = (0, _from.default)(new _set.default(keys));
  return keys;
}